import ResetPassword from "../components/reset-password";

const ResetPasswordPage = () => {
  return <ResetPassword />;
};

export default ResetPasswordPage;
